import { z } from "zod";

export const scrapFormSchema = z.object({
  inventory_batch_id: z.string().optional().or(z.literal("")),
  material_id: z.string().min(1, "Material required"),
  location_id: z.string().min(1, "Location required"),
  weight: z.coerce.number().positive("Weight must be > 0"),
  quantity: z.coerce.number().min(0).default(0),
  reason: z.string().trim().min(1, "Reason required").max(200),
  notes: z.string().optional().or(z.literal("")),
});

export type ScrapFormValues = z.infer<typeof scrapFormSchema>;

export const emptyScrapForm: ScrapFormValues = {
  inventory_batch_id: "",
  material_id: "",
  location_id: "",
  weight: 0,
  quantity: 0,
  reason: "",
  notes: "",
};
